import { render } from "./cards_products.vue?vue&type=template&id=270ee8cc"
import script from "./cards_products.vue?vue&type=script&lang=js"
export * from "./cards_products.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__